import PropTypes from "prop-types";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import AsyncSelect from "react-select/async";

import { fetchAccountSuggestions } from "../modules/urlEntry/thunks.js";

const styles = {
  groupLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  groupBadge: {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  },
};

export const LABELS = {
  AksAccount: "Aks accounts",
  User: "Aks accounts",
  Department: "Afdelingen",
  Usergroup: "Afdelingen",
  Group: "Intranet groepen",
  GuestAccount: "Gast accounts",
  SpecialDepartment: "Speciale groepen/afdelingen", // For now only 600001 "Arriva Iedereen"
};

const messages = {
  placeholder: {
    id: "components.DriveSuggestFormElement",
    description: "Drive Suggest placeholder label",
    defaultMessage:
      "Search here for Aks Users, Guest users, Departments and Intranet groups...",
  },
};

const DriveSuggest = ({ onSelect, placeholder }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const loadOptions = async (query) => {
    let accountsSuggestions;
    try {
      accountsSuggestions = await dispatch(fetchAccountSuggestions(query));
    } catch (err) {
      console.error("Error fetching the account suggestions:", err);
    }

    return Object.keys(LABELS).map((key) => ({
      label: LABELS[key],
      options: (accountsSuggestions[key] || []).map((a) => ({
        label: a.displayName,
        value: a,
      })),
    }));
  };

  return (
    <AsyncSelect
      cacheOptions
      controlShouldRenderValue={false}
      placeholder={placeholder || intl.formatMessage(messages.placeholder)}
      name="drive-suggest"
      loadOptions={loadOptions}
      onChange={onSelect}
      formatGroupLabel={(data) => (
        <div style={styles.groupLabel}>
          <span>{data.label}</span>
          <span style={styles.groupBadge}>{data.options.length}</span>
        </div>
      )}
    />
  );
};

DriveSuggest.propTypes = {
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default DriveSuggest;
